import { userAuthenticationStatus } from 'enums/AuthenticationServicesEnums';
import { AppRoutes } from 'routes/routeConstants/appRoutes';

export const baseYear = 2015;
export const defaultYearTab = 'locationTab';
export const errorMessageForFieldInfo = 'Please enter data or enter 0';
export const numberErrorMessage = 'Value should be a number';
export const errorMessageForAddYearField = 'Year is required';
export const addYearButton = 'addButton';
export const activeTabQuery = 'activeTab';
export const isEditViewQuery = 'isEditView';
export const isFirstFlowQuery = 'isFirstFlow';
export const processingFacility = 'Processing facility';
export const year = 'year';
export const adePage = 'ade';
export const transportation = 'transportation';
export const commodity = 'commodity';
export const rawMaterial = 'raw-material';
export const deleteLocationYearTitle = `Are you sure you want to delete the location data for the year?`;
export const stationaryCombustion = 'Stationary Combustion';
export const mobileSources = 'Mobile Sources';
export const processSources = 'Process Sources';
export const fugitiveEmissions = 'Fugitive Emissions';
export const locationBased = 'Location Based';
export const marketBased = 'Market Based';
export const defaultErrorMessage = 'Something went wrong';
export const addProductTitle = 'Add Product';
export const addProductSubTitle =
  'Create product to know the carbon footprint of the product';
export const isProcessingFacility = 'isProcessingFacility';
export const params = [isProcessingFacility, 'belongsId'];
export const scope3 = 'scope3';
export const requiredErrorMessage = 'Field is required';
export const totalWeightRequiredError = `Products' Total Weight is required`;
export const min1Value = `Products' Total Weight cannot be less than 1`;
export const wasteTypesKey = 'waste_types';
export const KEYDOWN_ENTER = 'Enter';
export const ELEMENT_INPUT = 'input';
export const MAX_FOUR_DECIMALS_REGEX = /^\d+(\.\d{1,4})?$/;
export const MAX_TWO_DECIMALS_REGEX = /^\d+(\.\d{1,2})?$|^-?\d+e\+\d+$/;
export const atleastOneRequired = 'Atleast one field is required';
export const errorMessageForWasteTypes =
  'Sum of waste type should equal total waste produced';
export const width88Class = 'width--88';
export const marketBasedRECField = 'electricity_from_REC';
export const category5 = 'category_5';
export const category11 = 'category_11';
export const category12 = 'category_12';
export const scopeTab = 'scopeTab';
export const ambientTemperature = 'ambient';
export const dataUpdatedMessage = 'Data Updated';
export const commodityDeletedMessage = 'Commodity deleted successfully';
export const integerErrorMessage = 'Only whole numbers are allowed';
export const percentageAtLeastOneErrorMessage = 'Total % must be at least 1';
export const percentageExceedErrorMessage = 'Total % cannot exceed 100%';
export const landChangePercentageAtLeastOneErrorMessage =
  'Land change % must be at least 1';
export const landChangePercentageExceedErrorMessage =
  'Land change % cannot exceed 100%';
export const cropResidueSumErrorMessage =
  'Sum of all crop residue % must equal 100%';
export const SoilMatterAtLeastErrorMessage =
  'Soil organic matter % must be at least 1';
export const SoilMatterExceedErrorMessage =
  'Soil organic matter % cannot exceed 100%';
export const SoilCarbonAtLeastErrorMessage =
  'Soil organic carbon % must be at least 1';
export const SoilCarbonExceedErrorMessage =
  'Soil organic carbon % cannot exceed 100%';
export const SoilCarbonDecimalErrorMessage =
  'Soil organic carbon % can have up to 2 decimal places';
export const SoilMatterDecimalErrorMessage =
  'Soil organic matter % can have up to 2 decimal places';
export const LandChangeDecimalErrorMessage =
  'Land change % can have up to 2 decimal places';
export const totalCropDecimalErrorMessage =
  'Total crop residue can have up to 2 decimal places';
export const duplicateItemErrorMessage = 'Duplicate item selected';
export const StageUpdatingMessage = {
  STAGE_2: 'Transportation Updated Successfully',
  STAGE_3: 'Fuel And Energy Updated Successfully',
  STAGE_4: 'Field Updated Successfully',
};
export const testName = {
  CROP_SUM: 'crop-sum',
  DECIMAL_PRECISION: 'decimal-precision',
  IS_NUMBER: 'is-number',
};

export const validationModal = {
  BUTTON: 'Go back',
  MESSAGE: 'Please complete scope 1, 2 before creating a commodity',
  ALT_TEXT: 'Warning',
};
export const commodityEmptyState = {
  TITLE: 'Add commodity',
  SUBTITLE_1: 'Please complete Scope 1, 2 to create commodity',
  SUBTITLE_2: 'List down your farm outputs',
  AGRICULTURE_TITLE: 'Add Agriculture commodity',
  LIVE_STOCK_TITLE: 'Add Livestock commodity',

};

export const commodityTotalCalculation = {
  QUANTITY_TITLE: 'Total quantity produced (kg)',
  REVENUE_TITLE: '% of farm revenue covered',
  PERCENTAGE_UNIT: '%',
};

export const commodityEmptyStateDefaultValues = {
  TITLE: 'No Commodities Yet',
  SUBTITLE:
    'It Looks A Bit Empty Here! To Get Started, Create Your First Commodity In Activity Data Entry',
};

export const commodityValidationNote = {
  MESSAGE:
    'The total % of farm revenue is incomplete. Add missing commodities or adjust the % values so that the total equals 100%.',
  BACKGROUND_COLOR_STYLE: '#EDF4F5',
  COLOR_STYLE: '#66939F',
};
export const addCommodityTitle = 'Add Commodity';
export const addCommoditySubTitle =
  'Create Commodity To Know The Carbon Footprint Of The Commodity';
export const AdePageCommoditySize = 50;

export const stepsURLs = [
  AppRoutes.ADMIN_INFO,
  AppRoutes.COMPANY_ADDRESS,
  AppRoutes.COMPANY_DETAILS,
  AppRoutes.PLAN_DETAILS,
  AppRoutes.VERIFY_EMAIL,
];

export const registerStepsURLs = [AppRoutes.ADMIN_INFO, AppRoutes.VERIFY_EMAIL];

export const steps = {
  [userAuthenticationStatus.VERIFICATION_PENDING]: AppRoutes.ADMIN_INFO,
  [userAuthenticationStatus.COMPANY_INFO_PENDING]: AppRoutes.COMPANY_DETAILS,
  [userAuthenticationStatus.COMPANY_ADDRESS_PENDING]: AppRoutes.COMPANY_ADDRESS,
  [userAuthenticationStatus.PAYMENT_PENDING]: AppRoutes.PLAN_DETAILS,
};

export const notificationVariableKeys = {
  productId: 'product_id',
  commodityId: 'commodity_id',
};

export const percantegeTotalError = 'Total Percentage should be 100%'

// Currency constants
export const CURRENCIES = {
  EUR: 'EUR',
  USD: 'USD',
  CAD: 'CAD',
} as const;

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  CAD: '$',
} as const;

export const CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR (€)' },
  { value: 'USD', label: 'USD ($)' },
  { value: 'CAD', label: 'CAD ($)' },
];
